import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AdminService } from '../../shared/services/admin/admin.service';
import { ErrorHandlerUtil } from './utils';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const adminService = inject(AdminService);
  const messageService = inject(MessageService);
  // Don't add token to the login endpoint itself
  if (req.url.includes('/api/Authentication/Login')) {
    return next(req);
  }
  // Add token to request if it exists
  const token = localStorage.getItem('APIKeyCMS');
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const token = localStorage.getItem('APIKeyCMS');
      // If token is missing or expired, try to get a new one
      if (ErrorHandlerUtil.isAuthError(error.status, token)) {
        console.warn('Token issue detected, attempting to refresh token');
        return adminService.postLoginTokenForCMS().pipe(
          switchMap((res: any) => {
            // Store the new token
            localStorage.setItem('APIKeyCMS', res.Token);
            const expiryTime = new Date();
            expiryTime.setHours(expiryTime.getHours() + 24);
            localStorage.setItem('APIKeyCMS_EXPIRY', expiryTime.toISOString());
            // Retry the original request with the new token
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${res.Token}`,
                'Content-Type': 'application/json'
              }
            });
            return next(retryReq);
          }),
          catchError((tokenError) => {
            console.error('Failed to refresh token:', tokenError);
            localStorage.removeItem('APIKeyCMS');
            localStorage.removeItem('APIKeyCMS_EXPIRY');
            ErrorHandlerUtil.showAuthErrorToast(messageService);
            return throwError(() => error);
          })
        );
      }
      // Handle other API errors with user-friendly messages
      if (!ErrorHandlerUtil.shouldSkipToast(req.url, req.headers)) {
        const errorMessage = ErrorHandlerUtil.getErrorMessage(error);
        ErrorHandlerUtil.showErrorToast(messageService, errorMessage);
      }
      // Always log the error for debugging
      ErrorHandlerUtil.logError(error);
      return throwError(() => error);
    })
  );
};
